import Login from './login';
import NoLogin from './noLogin';
import ModalsLib from '../../../../lib/modals';

export default ({game, login}) => {
    return (
        <div className="game-info">
            <div className="game-details">
                <div className="image" style={{backgroundImage: `url(${window.location.origin}/source/system/games/squad_new/${game.slug}.png)`, backgroundSize: '100%'}}></div>
                {/* <div className="image" style={{backgroundImage: `url(${window.location.origin}/source/system/games/vertical/${game.slug}.png)`, backgroundSize: 'cover', backgroundPosition: 'center center'}}></div> */}
                <div className="game-data">
                    <div className="left">
                        <div className="title">{game.name}</div>
                        <div className="descriptions">{game.descriptions}</div>
                    </div>

                    <div className="buttons">
                        {game.allows.download && (
                            <div className={`download ${!game.allows.web ? 'only' : ''}`} onClick={e => ModalsLib.open('download', {
                                game: game.slug
                            })}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_673_1933)">
                                        <path d="M12.4444 16H3.55555C2.60588 16 1.71302 15.6302 1.04142 14.9586C0.369847 14.287 0 13.3941 0 12.4444V11.5555C0 11.0646 0.397948 10.6666 0.888894 10.6666C1.37984 10.6666 1.77779 11.0646 1.77779 11.5555V12.4444C1.77779 12.9193 1.96273 13.3657 2.29845 13.7015C2.63426 14.0372 3.08068 14.2222 3.55555 14.2222H12.4444C12.9193 14.2222 13.3657 14.0372 13.7015 13.7015C14.0372 13.3656 14.2222 12.9192 14.2222 12.4444V11.5555C14.2222 11.0646 14.6202 10.6666 15.1111 10.6666C15.602 10.6666 16 11.0646 16 11.5555V12.4444C16 13.3941 15.6302 14.2869 14.9586 14.9586C14.287 15.6302 13.3941 16 12.4444 16ZM7.99998 12.4444C7.76788 12.4447 7.54491 12.3539 7.37903 12.1916L7.37897 12.1915L7.3772 12.1898L7.3767 12.1893C7.3762 12.1888 7.37577 12.1884 7.3753 12.1879L7.3744 12.187C7.37408 12.1867 7.37375 12.1864 7.37341 12.186L7.37148 12.1841L3.81591 8.62852C3.46879 8.2814 3.46879 7.71857 3.81591 7.37142C4.16302 7.0243 4.72588 7.02427 5.073 7.37142L7.11112 9.40954V0.888894C7.11109 0.397948 7.50904 0 7.99998 0C8.49093 0 8.88891 0.397948 8.88891 0.888894V9.40951L10.927 7.37142C11.2741 7.0243 11.837 7.0243 12.1841 7.37142C12.5312 7.71854 12.5312 8.2814 12.1841 8.62852L8.62852 12.1841L8.62659 12.186L8.6256 12.1869L8.6247 12.1878C8.62426 12.1883 8.62377 12.1888 8.62333 12.1892L8.6228 12.1897C8.62224 12.1903 8.62166 12.1909 8.62106 12.1915L8.621 12.1915C8.61122 12.201 8.60132 12.2103 8.59119 12.2193C8.51863 12.2841 8.43585 12.3366 8.3462 12.3744L8.34533 12.3748C8.34499 12.3749 8.34471 12.3751 8.34437 12.3752C8.23535 12.421 8.11825 12.4446 7.99998 12.4444Z" fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_673_1933">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>


                                <span>Download</span>
                            </div>
                        )}

                        {game.allows.web && (
                            <div className="play" onClick={e => {
                                if(game.slug === 'exito')
                                    window.open(game.links.play, '_blank');
                                else
                                    ModalsLib.open('game', {
                                        game: game.slug
                                    });
                            }}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 9.00004V6.33004C3 3.01504 5.3475 1.65754 8.22 3.31504L10.5375 4.65004L12.855 5.98504C15.7275 7.64254 15.7275 10.3575 12.855 12.015L10.5375 13.35L8.22 14.685C5.3475 16.3425 3 14.985 3 11.67V9.00004Z" fill="white"/>
                                </svg>

                                <span>Play Game</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="line"></div>

            {login ? <Login login={login} /> : <NoLogin login={login} />}
        </div>
    )
}